export function SetUserId(id: string | number){
    if(id){
        sessionStorage.setItem("wf2-STRY0045127-id", id.toString());
    }else {
        console.log("Impossible Error, User ID should not be empty! ");
    }
}
export function GetUserId(): string | number | null {
    const userIdText = sessionStorage.getItem("wf2-STRY0045127-id");
    if(!userIdText){
        return null;
    }
    const userIdNumber = parseInt(userIdText);
    return !!userIdNumber? userIdNumber : (userIdText || "");
}